// ─── THE LIVING ENCYCLOPEDIA, FOR PROMPTS ───────────────────────────────────
//
// Haley 2026-08-30: "make sure that the dictionary/characters/encyclopedia are
// all hooked up to it so everything is consistent throughout the app" and
// "persist app wide even to ai interactions." Before this module, the
// encyclopedia_entries table — the layer she and Nicole edit — reached ZERO
// AI prompts (2026-08-30 parity audit): the only encyclopedia data in any
// prompt was the static LOCATIONS array. This loader is how their edits reach
// every character.
//
// CACHE DISCIPLINE: rows are fetched once and reused for TTL minutes, ordered
// by id so the prompt text built from them is byte-stable between edits —
// the sections they feed live in the CACHED stable half of the anchor, and a
// wobbling byte breaks the provider prompt cache. An edit invalidates
// immediately via invalidateEncyclopediaCache() (called by the editor on
// save) and via the dictionary's realtime subscription; otherwise the TTL
// catches cross-device edits.

import { supabase } from './supabaseClient.js';

const TTL_MS = 5 * 60 * 1000;
let cachedRows = null;
let cachedAt = 0;
let inflight = null;

export async function loadEncyclopediaRows() {
  if (cachedRows && Date.now() - cachedAt < TTL_MS) return cachedRows;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const { data, error } = await supabase
        .from('encyclopedia_entries').select('*').order('id');
      if (error) {
        // Stale beats broken: keep serving the last good rows.
        console.warn('[encyclopediaLive] load failed:', error.message);
        return cachedRows || [];
      }
      cachedRows = data || [];
      cachedAt = Date.now();
      return cachedRows;
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}

export function invalidateEncyclopediaCache() {
  cachedAt = 0;
}
